import React from 'react';
import { Testimonials } from '../components/Testimonials';
export function Testimonios() {
  return <div className="pt-24" data-id="element-435">
      <Testimonials data-id="element-436" />
    </div>;
}